import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = Record<string, never>;

type PaidToTwcModalComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{ onClose: () => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<PaidToTwcModalComponent, EntryPointParams> = createEntryPoint({
	root: JSResourceForInteraction<PaidToTwcModalComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-paid-to-twc-modal" */ './paid-to-twc-modal',
		{
			moduleId: 'edition-awareness-paid-to-twc-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});
